













import { Validator } from '@tt4b/ttam-hooks';
import { toRefs, defineComponent, PropType, ref, nextTick, onMounted, watch, computed } from '@vue/composition-api';
import PhoneNumberInput from '@ad/phonenumber-input-sdk';
import { AcoFormData, FullNormalFormData } from '@tt4b/ttam-enums';

const name = 'ttam-instant-message-app-whatsapp-id';
export default defineComponent({
  name,
  props: {
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    imaWhatsappIdValidate: {
      type: Array as PropType<Validator>,
      default: () => [],
    },
    currentLang: {
      type: String,
      require: true,
      default: '',
    },
    accountCountry: {
      type: String,
      require: true,
      default: '',
    },
    currentCreativeUuid: {
      type: String,
      require: true,
      default: '',
    },
    currentAdSource: {
      type: Number,
      require: true,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { creativeData, currentLang, disabled, currentCreativeUuid, currentAdSource, accountCountry } = toRefs(props);
    const phoneNumberRef = ref();
    const phoneCountryCode = computed(() => creativeData.value?.phoneCountryCode || accountCountry.value || '');
    const phoneNumber = computed(() => creativeData.value?.phoneNumber || '');
    const phoneZipCode = computed(() => creativeData.value?.phoneZipCode || '');
    const hasValidateMessage = computed(() => Boolean(phoneNumberRef.value?.validateMessage));
    const ignoreValidateWarning = ref(false);

    const validatePhoneData = () => {
      nextTick(() => {
        phoneNumberRef.value?.validate('custom');
        emit('validate', !hasValidateMessage.value);
        if (ignoreValidateWarning.value) {
          ignoreValidateWarning.value = false;
          phoneNumberRef.value?.clearValidate();
        }
      });
    };

    const phoneInstance = new PhoneNumberInput('#phone-input', {
      lang: currentLang.value,
      value: {
        // 默认值
        country: phoneCountryCode.value,
        code: phoneZipCode.value,
        mobile: phoneNumber.value,
      },
      disabled: disabled.value,
      validate: false,
      // 手机号码或地域改变
      onChange: data => {
        emit('change', data);
      },
      onBlur: () => {
        validatePhoneData();
      },
      onAreaChange: () => {
        validatePhoneData();
      },
    });

    const setComponentDefaultValue = (data: {
      phoneZipCode: string;
      phoneNumber: string;
      phoneCountryCode: string;
    }) => {
      phoneInstance.setAreaAndPhone({
        country: data.phoneCountryCode || '',
        code: data.phoneZipCode || '',
        mobile: data.phoneNumber || '',
      });
    };

    onMounted(async () => {
      ignoreValidateWarning.value = true; // 初次见面，忽略校验提示
      await phoneInstance.render();
    });

    watch(
      () => currentCreativeUuid.value,
      () => {
        nextTick(() => {
          setComponentDefaultValue({
            phoneZipCode: phoneZipCode.value,
            phoneNumber: phoneNumber.value,
            phoneCountryCode: phoneCountryCode.value,
          });
        });
      },
    );

    watch(
      () => currentAdSource.value,
      () => {
        nextTick(() => {
          setComponentDefaultValue({
            phoneZipCode: phoneZipCode.value,
            phoneNumber: phoneNumber.value,
            phoneCountryCode: phoneCountryCode.value,
          });
        });
      },
    );

    return {
      name,
      phoneNumberRef,
      hasValidateMessage,
    };
  },
});
